import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=1c295564&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c295564"]])

export default __exports__